<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{$route.meta.title}}</h4>
            <!--<p class="category">A table for content management</p>-->
            <br />
          </div>
          <div v-if="$auth.user().isSuperuser || $root.expoStatPermissions.stands[standId]">
            <paginated-table :table-data="[]" :remote-url="remoteUrl" :per-page="10"
                             classes="table-persons"
                             ref="table"
                             v-loading="loading"
                             default-ordering="-person__barcode"
                             v-if="currentEvent"
                             :search-fields="['fullName', 'company', 'phone', 'email']">
              <template slot="buttons">
                <el-tooltip :content="'Download database in Excel format' | translate" placement="bottom" v-if="$auth.user().isSuperuser || $root.expoStatPermissions.stands[standId]">
                  <button class="btn btn-round btn-success" @click="exportPersons" ><translate>Export</translate></button>
                </el-tooltip>
              </template>
              <template slot-scope="slot" slot="tableColumns">
                <el-table-column
                  sortable="custom" sort-by="person__barcode"
                  min-width="120" :label="'Barcode' | translate" fixed>
                  <template slot-scope="props">
                    {{props.row.person.barcode}}
                  </template>
                </el-table-column>
                <el-table-column min-width="120" :label="'Full name' | translate" resizable>
                  <template slot-scope="props">
                    {{props.row.person.data.fullName || '-'}}
                    <!--<p>{{props.row.subTitle}}</p>-->
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="100"
                  resizable
                  :label="'Company' | translate">
                  <template slot-scope="props">
                    {{props.row.person.data.company || '-'}}
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="100"
                  :label="'Phone' | translate">
                  <template slot-scope="props">
                    <a :href="`tel:${props.row.person.data.phone}`" v-if="props.row.person.data.phone">{{props.row.person.data.phone}}</a>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="100"
                  label="Email">
                  <template slot-scope="props">
                    <a :href="`mailto:${props.row.person.data.email}`" v-if="props.row.person.data.email">{{props.row.person.data.email}}</a>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="100"
                  fixed="right"
                  :label="'Visited' | translate">
                  <template slot-scope="props">
                    <el-tooltip :content="props.row.firstActivity | moment('DD.MM.YYYY hh:mm:ss')" placement="top">
                      <span>{{ props.row.firstActivity | moment("from") }}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="100"
                  fixed="right"
                  :label="'Interested' | translate">
                  <template slot-scope="props">
                    <i :class="props.row.isInterested ? 'nc-icon nc-check-2': 'nc-icon nc-simple.remove'"></i>
                  </template>
                </el-table-column>

                <el-table-column
                  class-name="action-buttons td-actions"
                  align="right"
                  v-if="$auth.user().isSuperuser"
                  :label="'Actions' | translate">
                  <template slot-scope="props">
                    <!--                  <el-tooltip :content="'Edit' | translate" placement="top" v-if="$auth.user().isSuperuser || $root.expoStatPermissions.stands[props.row.id]">-->
                    <!--                    <router-link :to="{name: 'stands-edit', params: {standId: props.row.id}}" class="btn btn-icon btn-success btn-sm" tag="a">-->
                    <!--                      <i class="fa fa-edit"></i>-->
                    <!--                    </router-link>-->
                    <!--                  </el-tooltip>-->
                    <el-tooltip :content="'Update information' | translate" placement="right" v-if="$auth.user().isSuperuser">
                      <p-button type="info" round size="sm" icon @click="(e) => handleUpdateInformation(e, props.$index, props.row)">
                        <i class="fa fa-refresh"></i>
                      </p-button>
                    </el-tooltip>
                    <!--                  <el-tooltip :content="'More Info' | translate" placement="top">-->
                    <!--                    <router-link :to="{name: 'stands-details', params: {standId: props.row.id, standInfo: props.row}}"-->
                    <!--                                 class="btn btn-icon btn-secondary btn-sm" tag="a">-->
                    <!--                      <i class="fa fa-chevron-circle-right"></i>-->
                    <!--                    </router-link>-->
                    <!--                  </el-tooltip>-->
                  </template>
                </el-table-column>

                <!--<el-table-column-->
                <!--min-width="150"-->
                <!--label="Посещения"-->
                <!--class="td-number td-quantity">-->
                <!--<template slot-scope="props">-->
                <!--{{props.row.visits}}-->
                <!--&lt;!&ndash;<div class="btn-group">&ndash;&gt;-->
                <!--&lt;!&ndash;<button class="btn btn-sm" @click="props.row.quantity > 0 ? props.row.quantity&#45;&#45; : 0"><i class="ti-minus"></i></button>&ndash;&gt;-->
                <!--&lt;!&ndash;<button class="btn btn-sm" @click="props.row.quantity++"><i class="ti-plus"></i></button>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column label="Total"  min-width="100">-->
                <!--<template slot-scope="props">-->
                <!--<strong><small>&euro;</small> {{props.row.quantity * props.row.price}} </strong>-->
                <!--</template>-->
                <!--</el-table-column>-->
              </template>
            </paginated-table>
          </div>
          <div v-else>
            <h1>Нет доступа в данный раздел</h1>
          </div>

          <!--<div class="col-sm-6">-->
            <!--<div class="form-group">-->
              <!--<label class="control-label">Отображать на странице</label>-->
              <!--<el-select-->
                <!--class="select-default"-->
                <!--v-model="pagination.perPage"-->
                <!--placeholder="Отображать на странице">-->
                <!--<el-option-->
                  <!--class="select-default"-->
                  <!--v-for="item in pagination.perPageOptions"-->
                  <!--:key="item"-->
                  <!--:label="item"-->
                  <!--:value="item">-->
                <!--</el-option>-->
              <!--</el-select>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="col-sm-6">-->
            <!--<div class="pull-right">-->
              <!--<label>-->
                <!--<input type="search" class="form-control input-sm" placeholder="Поиск" v-model="searchQuery" aria-controls="datatables">-->
              <!--</label>-->
            <!--</div>-->
          <!--</div>-->

          <!--<div class="col-sm-6 pagination-info">-->
            <!--<p class="category">Отображается с {{from + 1}} по {{to}} из {{total}} записей</p>-->
          <!--</div>-->
          <!--<div class="col-sm-6">-->
            <!--<p-pagination class="pull-right"-->
                          <!--v-model="pagination.currentPage"-->
                          <!--:per-page="pagination.perPage"-->
                          <!--:total="pagination.total">-->
            <!--</p-pagination>-->
          <!--</div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import PaginatedTable from 'src/components/Expostat/Components/PaginatedTable'
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'


  import {Table, TableColumn, Tooltip} from 'element-ui'
  // import PSwitch from 'src/components/UIComponents/Switch.vue'
  // import PPagination from 'src/components/UIComponents/Pagination.vue'
  import testData from './demo-stand-1-persons.json'
  import info from './demo-stand-1.json'
  import swal from 'sweetalert2'
  import HumanizedDate from '../Components/HumanizedDate'
  // Vue.use(Table)
  // Vue.use(TableColumn)

  function b64DecodeUnicode (str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
  }

  export default{
    components: {
      PaginatedTable,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Tooltip.name]: Tooltip,
      HumanizedDate,
    },
    breadcrumb () {
      return {
        label: this.$gettext('Visitors list'),
        parent: {
          name: "stands-details"
        }
      }
    },
    props: {
      standId: {
        type: Number,
        default () {
          return parseInt(this.$route.params.standId)
        }
      }
    },
    computed: {
      ...mapState({
        currentEvent: state => state.events.current,
        currentEventInfo: state => state.events.currentEventInfo,
        // available: state => state.events.available
      }),
      remoteUrl () {
        return `expostat/event/${this.currentEvent}/stands/${this.standId}/persons/`
      }
    },
    mounted () {
      // this.$route.meta.title = `Посетители стенда ${this.info.title}`
    },
    data () {
      return {
        loading: false,
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        info: info,
        searchQuery: '',
        propsToSearch: ['fullName', 'company', 'phone', 'email'],
        tableData: testData,
        tmptableData: [
          {
            id: 1,
            image: 'static/img/tables/agenda.png',
            title: 'Notebook',
            subTitle: 'Most beautiful agenda for the office.',
            number: 49,
            visits: 112
          },
          {
            id: 2,
            image: 'static/img/tables/stylus.jpg',
            title: 'Stylus',
            subTitle: 'Design is not just what it looks like and feels like. Design is how it works.',
            number: null,
            visits: 200
          },
          {
            id: 3,
            image: 'static/img/tables/evernote.png',
            title: 'Evernote iPad Stander',
            subTitle: 'A groundbreaking Retina display. All-flash architecture. Fourth-generation Intel processors.',
            number: 40,
            visits: 15
          }
        ]
      }
    },
    methods: {
      handleLike (index, row) {
        alert(`Your clicked on Like button`)
      },
      handleEdit (index, row) {
        alert(`Your want to edit ${row.name}`)
      },
      handleDelete (index, row) {
        alert(`Your want to delete ${row.name}`)
      },
      async exportPersons () {
        console.log(this)
        // window.open(`${this.remoteUrl}export/`, '_blank')
        try {
          swal({
            title: this.$gettext('File formation'),
            html: this.$gettext('Please wait...'),
            onOpen: () => {
              swal.showLoading()
            }
          })

          const response = await this.$http.get(`${this.remoteUrl}export/`, { responseType: 'blob' })
          swal.close()
          let filename = /=\?utf-8\?b\?(.+)\?=/.exec(response.headers.filename)
          if (filename !== null) {
            filename = b64DecodeUnicode(filename[1])
          } else {
            filename = response.headers.filename
          }
          if (!window.navigator.msSaveOrOpenBlob) {
            // BLOB NAVIGATOR
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
          } else {
            // BLOB FOR EXPLORER 11
            const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename)
          }
        } catch (e) {
          console.error(e)
          let message = this.$gettext('An error occurred while generating the file. Try again later or contact technical support.')
          if (e.response && e.response.status === 403) {
            message = this.$gettext('Access denied!')
          }
          swal({
            type: 'error',
            title: this.$gettext('Error'),
            html: message
          })
        }

      },
      async handleUpdateInformation(e, index, row) {
        this.loading = true
        try {
          const result = await this.$http.post(`expostat/event/${this.currentEvent}/stands/${this.standId}/persons/${row.id}/update-info/`)
          if (result.status === 200) {
            this.$refs.table.remoteData[index] = result.data
            this.$refs.table.remoteData = [...this.$refs.table.remoteData]
            // row.data = result.data.data
          }
        } catch (e) {
          console.error(e)
        }
        this.loading = false

      }
      // getSummaries (param) {
      //   const { columns } = param
      //   const sums = []
      //   columns.forEach((column, index) => {
      //     if (index === 0) {
      //       sums[index] = 'Total'
      //     } else if (index < columns.length - 1) {
      //       sums[index] = ''
      //     } else {
      //       let sum = 0
      //       this.productsTable.forEach((obj) => {
      //         sum += obj.quantity * obj.price
      //       })
      //       sums[index] = `€ ${sum}`
      //     }
      //   })
      //   return sums
      // }
    }
  }
</script>
<style>
  .table-persons table > tbody > tr > td {
    padding: 2px 0;
  }
</style>
